import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Grid from '../components/Grid.jsx';
import styles from '../styles/styles.js';
import { DatePicker } from '../index.js';
const { makeStyles } = styles;

const GridDatePicker = ({ gridProps, ...props }) => {
  const classes = useStyles();
  const {
    label,
    value,
    name,
    format,
    valueFormat,
    disabled,
    pickerProps,
    error,
  } = props;

  const dataTestId = props['data-testid'];

  const handleDateChange = (dateMoment) => {
    console.log('handleDateChange', dateMoment);
    props.onChange(name, dateMoment);
  };

  return (
    <Grid item {...gridProps}>
      <div
        className={
          classNames(classes.dateContainer, props.className)
        }>
        <DatePicker
          data-testid={dataTestId}
          {...props}
          {...pickerProps}
          ampm={false}
          disabled={disabled}
          value={value}
          format={format || 'yyyy-MM-DD'}
          valueFormat={valueFormat}
          error={error}
          label={label}
          onChange={handleDateChange}
          name={name}
        />
      </div>
    </Grid>
  );
};

const useStyles = makeStyles(theme => ({
  dateContainer: {
    position: 'relative',
  },
}));

GridDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default GridDatePicker;
